var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curso-main-container pb-3"},[_c('BannerInterno'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container tarjeta tarjeta--blanca p-4 p-md-5 mb-5"},[_c('div',{staticClass:"titulo-principal color-acento-contenido"},[_c('div',{staticClass:"titulo-principal__numero"},[_c('span',[_vm._v("5")])]),_c('h1',[_vm._v("Tema 5")])])])
}]

export { render, staticRenderFns }